'use strict';

class AjaxParts {
    /**
     *
     * @param e - selector for append
     * @param params - json, (url and data)
     *
     * Example:
     * let callback = function() {};
     *
     * let request = new AjaxParts('.selector', {
     *    url:url,
     *    data:false,
     *    callback:callback
     * });
     */
    constructor(e, params) {
        this.cls = $(e);
        this.params = params;
    }

    ajaxRequest() {

        let append_cls = this.cls;
        let params = this.params;

        $.ajax({
            url: params.url,
            type: 'POST',
            dataType: 'json',
            data: params.data,
            beforeSend: function () {
                //TODO add before send params, maybe block form and etc..
            },
            complete: function () {
                //TODO add complete request action, maybe unblock form and etc..
            },
            success: function (data) {
                append_cls.append(data.response);

                if (params.callback) {
                     params.callback(data);
                }
            },
            error: function (data) {
                let notice = new Notice(false, 'Произошла ошибка, попробуйте позже!')
                notice.showNotice();
            }
        });
    }

}

